<template>
  <div class="svg10"
       ref="svgTarget">
    <svg height="200"
         preserveAspectRatio="xMidYMid meet"
         width="1000"
         xmlns="http://www.w3.org/2000/svg">
      <g v-for="(item,idx) in 5"
         :key="idx"
         :id="'group'+idx">
        <circle :cx="100+idx*200"
                cy="100"
                :fill="dataitem[idx]?'black':'#333'"
                r="90"
                stroke="white"
                stroke-width="5" />

        <circle :cx="100 +idx*200"
                cy="100"
                :fill="dataitem[idx]?(dataitem[idx].score==1?'white':'black'):'#333'"
                r="50"
                stroke="white"
                stroke-width="5" />
        <text v-if="dataitem[idx]&&dataitem[idx].ot!=''"
              fill="red"
              font-size="40"
              stroke-width="0"
              :x="70+idx*200"
              y="115">  {{dataitem[idx].ot}}</text>
        <g v-if="dataitem[idx]" :key="'shizihua'+idx">
          <line :x1="100 +idx*200 + dataitem[idx].x * targetScale-bulletRadius*6"
                :y1="100 - dataitem[idx].y* 1 * targetScale"
                :x2="100 +idx*200 + dataitem[idx].x * targetScale-bulletRadius"
                :y2="100 - dataitem[idx].y* 1 * targetScale"
                :stroke="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
                stroke-width=6 />
          <line :x1="100 +idx*200 + dataitem[idx].x * targetScale+bulletRadius*6"
                :y1="100 - dataitem[idx].y* 1 * targetScale"
                :x2="100 +idx*200 + dataitem[idx].x * targetScale+bulletRadius"
                :y2="100 - dataitem[idx].y* 1 * targetScale"
                :stroke="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
                stroke-width=6 />
          <line :x1="100 +idx*200 + dataitem[idx].x * targetScale"
                :y1="100 - dataitem[idx].y* 1 * targetScale+bulletRadius*8"
                :x2="100 +idx*200 + dataitem[idx].x * targetScale"
                :y2="100 - dataitem[idx].y* 1 * targetScale+bulletRadius"
                :stroke="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
                stroke-width=6 />
          <line :x1="100 +idx*200 + dataitem[idx].x * targetScale"
                :y1="100 - dataitem[idx].y* 1 * targetScale-bulletRadius*8"
                :x2="100 +idx*200 + dataitem[idx].x * targetScale"
                :y2="100 - dataitem[idx].y* 1 * targetScale-bulletRadius"
                :stroke="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
                stroke-width=6 />
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 子弹半径
      bulletRadius: 2.4,
      // 中心点
      centerPosition: 100,
      // 靶面宽度
      diameter: 1000,
      // 初始缩放比率
      initScale:1,
      //弹着半径缩放比率，50/62 62为9.7环半径 
      targetScale:50/62,
      // 负margin值 考虑面板大于显示框的情况
      marign: 0,
    }
  },
  methods: {
    // 设置css原始属性值（放大倍数scale ，偏移量 margin）
    setProperty: function (attribute, val) {
      this.$refs.svgTarget
        ? this.$refs.svgTarget.style.setProperty(attribute, val)
        : ""
    },
    scaleZoom: function () {
      const parentContainerWidth = document.getElementsByClassName(
        "targetContainer"
      )[0].clientWidth
      this.initScale = parentContainerWidth / this.diameter
      this.setProperty("--transScale", this.initScale)
    },
  },
  mounted() {
    // console.log(this.dataitem)
    this.scaleZoom()
    const parentContainerHeight = document.getElementsByClassName(
      "targetContainer"
    )[0].clientHeight

    // // 考虑面板大于显示框的情况
    if (parentContainerHeight < this.centerPosition * 2) {
      this.margin = (parentContainerHeight - this.centerPosition * 2) / 2 + "px"
      this.setProperty("--margin", this.margin)
    } else {
      this.margin = (this.centerPosition * 2 - parentContainerHeight) / 2 + "px"
      this.setProperty("--margin", this.margin)
    }
  },
  watch: {},
  props: ["dataitem"],
}
</script>
<style lang="less" scoped>
.svg10 {
  flex: 1;
  display: flex;
  align-items: center;
  --transScale: 1;

  --margin: 0px;
  position: absolute;
  svg {
    transform: scale(var(--transScale));
    margin-top: var(--margin);
  }
}
</style>
